import { notifications } from '@mantine/notifications';
import { replaceShortLink } from '../../apiClient';
import { useEntityQueryUpdate } from '../../../hooks/useEntityQueryUpdate';
import { useMutation } from '@tanstack/react-query';

const useReplaceShortLink = () => {
    const entityUpdater = useEntityQueryUpdate();

    const mutation = useMutation({
        mutationKey: 'replace_shortlink',
        mutationFn: (model) => replaceShortLink(model),
        onSuccess: (data, variables, ctx) => {
            entityUpdater([['short_links'], ['short_link', data.id]], data);
            notifications.show({
                title: 'Success',
                message: 'Successfully replaced shortlink',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return mutation;
};
export default useReplaceShortLink;
